/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ImportExamItemGridItemRepositoryResponse } from "../types/ImportExamItemGridItemRepositoryResponse.ts";

export const importExamItemGridItemRepositoryResponseSchema = z.object({
  id: z.optional(
    z.number().int().describe("ID da questão disponível para importação."),
  ),
  label: z.string().describe("Enunciado da questão. Opcional.").nullish(),
  componentType: z
    .string()
    .describe(
      "Tipo do componente da questão (descrição textual do formato, ex: MultipleChoice, TrueOrFalse). Opcional.",
    )
    .nullish(),
  personAuthorName: z
    .string()
    .describe("Nome do autor da questão. Opcional.")
    .nullish(),
  disciplineName: z
    .string()
    .describe("Nome da disciplina à qual a questão pertence. Opcional.")
    .nullish(),
  cultureInfo: z
    .string()
    .describe(
      "Código de cultura/idioma da questão (ex: pt-BR, en-US). Opcional.",
    )
    .nullish(),
  active: z.optional(
    z
      .boolean()
      .describe("Indica se a questão está ativa e disponível para uso."),
  ),
  weight: z.optional(
    z
      .number()
      .int()
      .describe("Peso da questão na composição da nota da prova."),
  ),
  creationDate: z
    .string()
    .datetime()
    .describe("Data e hora de criação da questão. Opcional.")
    .nullish(),
  lastChangeDate: z
    .string()
    .datetime()
    .describe("Data e hora da última alteração da questão. Opcional.")
    .nullish(),
}) as unknown as ToZod<ImportExamItemGridItemRepositoryResponse>;
